import React, {useEffect, useReducer} from "react";
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Alert from "@amzn/meridian/alert";
import {PrintDepartureSheetReducer} from "./reducers/PrintDepartureSheetReducer";

const initialState = {
    isSuccess: true
};

export const DepartureSheetResponse = ({checkedDrivers}) => {
    const [{isSuccess}, casDispatch] = useReducer(PrintDepartureSheetReducer, initialState);

    useEffect(() => {
        casDispatch({
            type: "PRINT_DEPARTURE_SHEET",
            data: {
                driversList: checkedDrivers,
                dispatcher: casDispatch
            }
        })
    }, []);

    if (!isSuccess) {
        return (
            <Row alignmentHorizontal="center" alignmentVertical="center">
                <Alert type="error">Error</Alert>
            </Row>
        );
    }
    return (<Box></Box>
    );
};


// WEBPACK FOOTER //
// ./src/components/departureSheet/DepartureSheetResponse.js